// js
import React, {Component} from 'react';
import PropTypes from 'prop-types';


class RecommendationChart extends Component {

  constructor(props) {
    super(props);
    this.USE_ICONS = ['could', 'should', 'partial', 'full'];
  }

  renderGoals(goals) {
    return goals.map((goal) => {
      if (goal.groups.length > 0){
        return (
          <tr className='row' key={goal.id}>
            <td><span className={`icon icon-use-${this.USE_ICONS[this.props.type]} icon-pptx`} /></td>
            <td className='col-xs-3'>{goal.title}</td>
            <td className='col-xs-9 chart__groups'>{ this.renderGroups(goal.groups)}</td>
          </tr>
        );
      }
    }).filter((row => row !== undefined));
  }

  renderGroups(groups) {
    return groups.map(group => <span key={group.id}>{group.title}</span>);
  }

  hasGoals(goals) {
    let count = 0;
    goals.forEach(goal => count += goal.groups.length);
    return count > 0;
  }

  render() {
    const goals = this.props.analysisGoals;
    if (goals.length > 0 && this.hasGoals(goals)) {
      return (
        <div className='chart__table'>
          <table className='table table-bordered table-striped'>
            <tbody>
              {this.renderGoals(goals)}
            </tbody>
          </table>
        </div>
      );
    } else {
      return (
        <h4 className='chart-headline'>There are no groups or key goals recommended for this area.</h4>
      );
    }
  }
}

RecommendationChart.propTypes = {
  analysisGoals: PropTypes.array,
  type: PropTypes.number
};

export default RecommendationChart;



// WEBPACK FOOTER //
// ./src/components/analytics/pptx/RecommendationChart.js